module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/quick_easy--xxs@2x-c1fd2ab6085ea2a72348440b44b6dd68.png";